import React from 'react'

function Footer() {
  return (
    <div className='py-10 flex  flex-col gap-10'>
    <div className='w-full h-[1px] bg-gray-700'></div>
    <div className='flex justify-center items-center gap-5'>
    <p className='text-gray-500 text-sm'>© 2023 Harshal Atre. All rights reserved.</p>
    </div>
    </div>
  )
}

export default Footer